/* global axios */
import ApiClient from './ApiClient';

class AutomationsAPI extends ApiClient {
  constructor() {
    super('automation_rules', { accountScoped: true });
  }

  clone(automationId) {
    return axios.post(`${this.url}/${automationId}/clone`);
  }

  simulateDateTrigger(payload) {
    return axios.post(`${this.url}/date_trigger/simulate`, payload);
  }

  runDateTriggerNow(automationId) {
    return axios.post(`${this.url}/${automationId}/date_trigger/run`);
  }

  getDateTriggerRuns(automationId, page = 1) {
    return axios.get(`${this.url}/${automationId}/date_trigger/runs`, {
      params: { page },
    });
  }

  getDateTriggerExecutions(automationId, runId, { status, page = 1 } = {}) {
    return axios.get(
      `${this.url}/${automationId}/date_trigger/runs/${runId}/executions`,
      { params: { status, page } }
    );
  }
}

export default new AutomationsAPI();
